import React, { useRef, useState } from 'react';
import { ILine as Line, IStage as Stage } from '../../../../global';
import { ReactComponent as MobileStockOnHandIcon } from '../../../../svg/icons/mobile/mobile-stock-on-hand.svg';
import moment from 'moment';
import makeStyles from '@material-ui/core/styles/makeStyles';
import TextDivider from '../../Dividers/TextDivider';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import StockOnHandMenu from '../Stages/StockOnHandMenu';

const useStyles = makeStyles((theme: any) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    marginBottom: theme.spacing(1.5),
  },
  icon: {
    borderRadius: 100,
    padding: theme.spacing(1),
    paddingTop: theme.spacing(0.5),
    paddingBottom: theme.spacing(0.5),
    boxShadow: theme.boxShadow.secondary,
    marginLeft: theme.spacing(1.5),
  },
  date: { marginLeft: theme.spacing(0.75), fontWeight: 'bold' },
}));

interface Props {
  stage: Stage;
  line: Line;
  handleStageUpdate?: (...args) => void;
  addOrDeleteError?: (...args) => void;
}

export default function MobileStockOnHand({
  line,
  stage,
  handleStageUpdate,
  addOrDeleteError,
}: Props) {
  const classes = useStyles();
  const ref = useRef();
  const [open, setOpen] = useState(false);
  const date = stage?.start ? moment(stage.start).format('MMM DD') : 'Date';

  return (
    <>
      <div className={classes.root}>
        <TextDivider
          margin={0.5}
          text={
            <Box display="flex" alignItems="center">
              Stock on Hand
              <div ref={ref}>
                <Box
                  display="flex"
                  alignItems="center"
                  className={classes.icon}
                  onClick={() => setOpen(!open)}
                >
                  <MobileStockOnHandIcon />
                  <Typography variant="body2" className={classes.date}>
                    {date}
                  </Typography>
                </Box>
              </div>
            </Box>
          }
        />
      </div>
      <StockOnHandMenu
        line={line}
        stockOnHand={stage}
        anchorEl={ref.current}
        open={open}
        setOpen={setOpen}
        handleStageUpdate={handleStageUpdate}
        addOrDeleteError={addOrDeleteError}
        stockOnHandPosition={100}
      />
    </>
  );
}
